import { EntityState } from "@ngrx/entity";

import { UserEntity } from '../entities';

export interface UserState extends EntityState<UserEntity> {
    loading: boolean,
    loaded: boolean,
    prevUrl: string,
    nextUrl: string,
    createdUserId: number
}